import { useCallback, useMemo } from "react";

import { useQueryString } from "modules/core/hooks/useQueryString";
import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";

import { getSubdomain } from "modules/core/utils/helpers";
import { sendTrackingEvent } from "modules/core/api/tracking";
import { trackingEvents } from "modules/core/config/tracking/events";

import { MosaicChatAgent } from "modules/chat/types/entities";

export const useMosaicChat = () => {
  const { urlQueries, overrideQS, removeFromQS } = useQueryString();

  const { data: user } = useAuthUserQuery();

  const agentId = urlQueries.agentId as MosaicChatAgent | null;

  const openChat = useCallback(
    (agentId: MosaicChatAgent) => {
      overrideQS({
        queryObject: {
          ...urlQueries,
          agentId
        },
        isReplace: true
      });

      sendTrackingEvent(trackingEvents.ai.opened_mosaic_chat);
    },
    [overrideQS, urlQueries]
  );

  const closeChat = useCallback(() => {
    removeFromQS({
      keys: ["agentId"],
      isReplace: true
    });
  }, [removeFromQS]);

  const threadId = useMemo(() => {
    const tenant = getSubdomain();

    if (agentId && user && tenant) {
      return `${user.id}:${tenant}:${agentId}`;
    }
  }, [agentId, user]);

  const canOpenChat = Boolean(user);

  return {
    canOpenChat,
    threadId,
    agentId,
    openChat,
    closeChat
  };
};
